import { KastConfig } from "../types";

export const kastConfigs: Record<string, KastConfig> = {
  kleine: {
    size: "kleine",
    boxCount: 12,
    label: "Kleine kast",
  },
  medium: {
    size: "medium",
    boxCount: 24,
    label: "Medium kast",
  },
  grote: {
    size: "grote",
    boxCount: 36,
    label: "Grote kast",
  },
};
